import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
const transformations = ['Palm trees trimmed clean and standing tall', 'That massive stump finally gone — flat, clean ground in its place', "The dead tree that's been leaning toward the fence — removed safely", 'A yard so clean your neighbors stop to ask who did it'];
export const TransformationSection = () => {
  return <section id="transformation" className="py-24 bg-offwhite" data-id="element-309">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-311">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-8 leading-tight" data-id="element-312">
            The Difference Between A Yard That Worries You And One That
            Impresses You Is One Phone Call
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-313">
            Think about what your yard could look like:
          </p>
        </motion.div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100" data-id="element-314">
          <div className="space-y-6 mb-12" data-id="element-315">
            {transformations.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-4" data-id="element-316">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center" data-id="element-317">
                  <CheckIcon className="w-6 h-6" data-id="element-318" />
                </div>
                <p className="text-xl text-gray-800 font-medium" data-id="element-319">{item}</p>
              </motion.div>)}
          </div>

          <div className="text-center p-6 bg-earth/10 rounded-2xl border border-earth/20" data-id="element-320">
            <p className="text-xl font-bold text-earth" data-id="element-321">
              That's not a fantasy. That's what happens every single day for
              homeowners who call South Coast Tree Care.
            </p>
          </div>
        </div>
      </div>
    </section>;
};